<template>
  <div>
    <base-header v-once></base-header>
    <v-list dense>
      <v-list-item-group color="primary">
        <v-list-item v-for="(item, i) in items" :key="i" v-on:click="showPopNoticeDetail(true, item)">
          <v-list-item-content>
            <v-list-item-title v-text="item.title"></v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-item-group>
    </v-list>
    <infinite-loading @infinite="infiniteHandler" spinner="waveDots">
      <div
        slot="no-more"
        style="color: rgb(102, 102, 102); font-size: 14px; padding: 10px 0px;"
      >목록의 끝입니다 :)</div>
    </infinite-loading>

    <pop-notice-detail
      :detail="detail"
      :popNoticeDetail.sync="popNoticeDetail"
      @self-show="showPopNoticeDetail"
      @child-attach-show="showPopAttachView"
    ></pop-notice-detail>

    <pop-attach-view
      :detail="detail"
      :popAttachView.sync="popAttachView"
      @self-show="showPopAttachView"
    ></pop-attach-view>
  </div>
</template>
<script>
import InfiniteLoading from "vue-infinite-loading";
import PopNoticeDetail from "@/components/notice/pop-notice-detail.vue";
import PopAttachView from "@/components/notice/pop-attach-view.vue";

export default {
  name: "Detail",
  components: {
    InfiniteLoading,
    PopNoticeDetail,
    PopAttachView
  },
  data() {
    return {
      msg: "Detail Component",
      product: "",
      detail: {
        id: '',
        title: ''
      },
      dialog: false,
      fullscreen: false,
      items: [],
      limit: 0,
      popNoticeDetail: false,
      popAttachView: false
    };
  },
  watch: {
    "$route.hash"(newHash, oldHash) {
      if (newHash === "#pop-attach-view") {
        this.popAttachView = true;
      } else if (oldHash === "#pop-attach-view") {
        this.popAttachView = false;
      }

      if (newHash === "#pop-notice-detail") {
        this.popNoticeDetail = true;
      } else if (oldHash === "#pop-notice-detail") {
        this.popNoticeDetail = false;
      }
    }
  },
  methods: {
    infiniteHandler($state) {
      var that = this;
      var parameters = {
        offset: this.limit,
        size: 20
      };
      this.$api.sample
        .list(parameters)
        .then(function(list) {
          if (list.length) {
            console.log("Detail.vue <infiniteHandler>", list);
            that.items = that.items.concat(list);
            $state.loaded();
            that.limit += 20;

            if (list.length < 20) {
              $state.complete();
            }
          } else {
            $state.complete();
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    showPopNoticeDetail: function(open, item) {
      if (open) {
        console.log("Detail.vue <showPopNoticeDetail.open>", open, "<item>", item);
        this.detail.id = item.id;
        this.detail.title = item.title;
        this.$router.push("#pop-notice-detail");
        this.popNoticeDetail = true;
      } else {
        this.popNoticeDetail = false;
        this.$router.back(); // 😎 back button click
      }
    },
    showPopAttachView: function(open, item) {
      if (open) {
        console.log(
          "Detail.vue <showPopAttachView.open>",
          open,
          "<item>",
          item
        );
        this.detail.id = item.id;
        this.detail.title = item.title;
        this.$router.push("#pop-attach-view");
        this.popAttachView = true;
      } else {
        this.popAttachView = false;
        this.$router.back(); // 😎 back button click
      }
    },
  },
  created: function() {
    console.log(this.$options.name, "테스트", this.$route.params);
  }
};
</script>
